
import { STATUS } from "../../Common/Entity/Enums";

export const getSelectedEntityStatus = (state) => {
  const supplier = state.entityReducer.selectedSupplierData;
  if (!supplier) return null;
  const entity = supplier.entity_info?.find(e => e.esi_id === state.entityReducer.selectedEntity)
    ?? supplier.entity_info?.[0];
  return entity?.status || null;
};


export const SET_SUPPLIERS = 'ENTITY/SET_SUPPLIERS';
export const SET_SELECTED_SUPPLIER = 'ENTITY/SET_SELECTED_SUPPLIER';
export const SET_SELECTED_ENTITY = 'ENTITY/SET_SELECTED_ENTITY';
export const SET_LOADING = 'ENTITY/SET_LOADING';
export const SET_ERROR = 'ENTITY/SET_ERROR';
export const CLEAR_ENTITY = 'ENTITY/CLEAR_ENTITY';
export const SET_ENTITY = 'ENTITY/SET_ENTITY';
export const RESET_SUPPLIERS = 'ENTITY/CLEAR_SUPPLIERS';



const initialState = {
  selectedEntityInfo: null,
  entity_info: [],
  suppliers: [],
  selectedSupplier: '',
  selectedEntity: '',
  selectedSupplierData: null,
  show_history: false,
  loading: false,
  error: null,
};

const entityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUPPLIERS:
      const suppliers = action.payload;
      const firstSupplier = suppliers.length > 0 ? suppliers[0] : null;
      const selectedSupplierId = state.selectedSupplier || (firstSupplier?.id || '');
      return {
        ...state,
        suppliers: suppliers,
        selectedSupplier: selectedSupplierId,
        selectedSupplierData: suppliers.find(s => s.id === selectedSupplierId) || null,
        loading: false,
        error: null,
      };
    case SET_SELECTED_SUPPLIER:
      const selectedSupplierData = state.suppliers.find(s => s.id === action.payload);
      return {
        ...state,
        selectedSupplier: action.payload,
        selectedSupplierData: selectedSupplierData || null,
      };
    case SET_ENTITY: {
      const firstEntityObj = Array.isArray(action.payload) && action.payload.length > 0 ? action.payload[0] : null;
      const firstEntityId = firstEntityObj ? firstEntityObj.esi_id : '';
      return {
        ...state,
        entity_info: action.payload,
        selectedEntity: firstEntityId,
        selectedEntityInfo: firstEntityObj,
        loading: false,
        show_history: firstEntityObj?.has_history  && firstEntityObj.status === STATUS.INACTIVE ||  false,
        error: null,
      };
    }
    case SET_SELECTED_ENTITY: {
      const entity = state.entity_info?.find(e => e.esi_id === action.payload) ?? state.entity_info?.[0];
      return {
        ...state,
        selectedEntity: action.payload,
        selectedEntityInfo: entity || null,
        show_history: (entity?.has_history && entity?.status === STATUS.INACTIVE) || false,
      };
    }
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case CLEAR_ENTITY:
      return {
        ...state,
        entity_info: [],
        selectedEntity: '',
        selectedEntityInfo: null,
        show_history: null,
      };
    case RESET_SUPPLIERS:
      return {
        ...state,
        suppliers: [],
        selectedSupplier: '',
        selectedSupplierData: null,
      };
      
    default:
      return state;
  }
};

export default entityReducer;
